/**
 * État complet des blocs Ginabella en une commande : window.gbDiag()
 *
 * Ne dépend d'aucun bloc : tout est lu dans le DOM. Fonctionne donc même quand un
 * composant a échoué à s'initialiser, ce qui est précisément le cas où on en a besoin.
 * Renvoie un objet à copier-coller, et affiche un verdict en clair.
 */

const valeurCocheeParmi = (champs) => {
  for (const champ of champs) {
    if (champ instanceof HTMLSelectElement) return champ.value;
    if (champ.checked) return champ.value;
  }
  return null;
};

const gbDiag = () => {
  const rapport = {
    page: location.host + location.pathname,
    apercuLocal: location.hostname === '127.0.0.1' || location.hostname === 'localhost',
  };

  // --- Sélecteur de variantes natif -----------------------------------------
  const picker = document.querySelector('variant-picker');
  if (picker) {
    const champs = Array.from(picker.querySelectorAll('input[type="radio"], select'));
    rapport.selecteurNatif = {
      present: true,
      classes: picker.className || '(aucune)',
      masqueParGbCache: picker.classList.contains('gb-cache'),
      nbChamps: champs.length,
      valeurCochee: valeurCocheeParmi(champs),
      champs: champs.map((c) => `${c.name}=${c.value}${c instanceof HTMLSelectElement || c.checked ? ' (coché)' : ''}`),
    };
  } else {
    rapport.selecteurNatif = {
      present: false,
      indice: 'Le bloc « Sélecteur de variantes » est-il désactivé ? Désactivé, il n\'est pas rendu du tout.',
    };
  }

  // --- Notre sélecteur de couleur -------------------------------------------
  const selecteur = document.querySelector('gb-selecteur-couleur');
  if (selecteur) {
    const entrees = Array.from(selecteur.querySelectorAll('input[type="radio"]'));
    rapport.selecteurCouleur = {
      present: true,
      nomChamp: selecteur.dataset.nomChamp || null,
      indexOption: selecteur.dataset.indexOption || null,
      nbPastilles: entrees.length,
      valeurCochee: valeurCocheeParmi(entrees),
      pastilles: entrees.map((e) => `${e.value}${e.checked ? ' (coché)' : ''}`),
    };
  } else {
    rapport.selecteurCouleur = { present: false };
  }

  // --- Offres groupées -------------------------------------------------------
  const bundle = document.querySelector('gb-bundle');
  if (bundle) {
    const items = Array.from(bundle.querySelectorAll('[data-ref="gb-bundle-item"]'));
    const reference = items.find((item) => item.dataset.nomChamp);
    rapport.bundle = {
      present: true,
      nomChamp: reference ? reference.dataset.nomChamp : null,
      indexOption: reference ? reference.dataset.indexOption : null,
      pastillesActivees: bundle.dataset.pastilles === 'true',
      paliers: items.map((item) => ({
        quantite: item.dataset.quantite,
        selectionne: item.classList.contains('gb-bundle-item--selectionne'),
        variantId: item.dataset.variantId,
        lignes: Array.from(item.querySelectorAll('[data-ref="gb-bundle-ligne"]')).map((ligne) => ({
          index: ligne.dataset.index,
          couleur: ligne.querySelector('.gb-bundle-item__pastille--active')?.dataset.valeur ?? null,
        })),
      })),
    };
  } else {
    rapport.bundle = { present: false };
  }

  // --- Cohérence -------------------------------------------------------------
  const reference = rapport.selecteurNatif.present ? rapport.selecteurNatif.valeurCochee : null;
  const anomalies = [];

  if (!rapport.apercuLocal) {
    anomalies.push("La page n'est pas l'aperçu local de theme dev : ce n'est peut-être pas la bonne version du thème.");
  }
  if (!rapport.selecteurNatif.present) {
    anomalies.push('Pas de sélecteur natif dans la page : rien à piloter.');
  }
  if (rapport.selecteurCouleur.present && reference && rapport.selecteurCouleur.valeurCochee !== reference) {
    anomalies.push(`Sélecteur de couleur désynchronisé : ${rapport.selecteurCouleur.valeurCochee} au lieu de ${reference}.`);
  }
  if (rapport.bundle.present && reference && rapport.bundle.pastillesActivees) {
    for (const palier of rapport.bundle.paliers) {
      const ligne1 = palier.lignes.find((l) => l.index === '1');
      if (ligne1 && ligne1.couleur !== null && ligne1.couleur !== reference) {
        anomalies.push(`Palier ${palier.quantite} : ligne #1 sur ${ligne1.couleur} au lieu de ${reference}.`);
      }
    }
  }

  rapport.anomalies = anomalies;

  console.log('%c[gbDiag]', 'font-weight:bold', reference ? `couleur de référence : ${reference}` : 'aucune couleur de référence');
  console.log(rapport);
  if (anomalies.length === 0) {
    console.log('%c[gbDiag] tout est cohérent', 'color:green');
  } else {
    anomalies.forEach((a) => console.warn('[gbDiag]', a));
  }

  return rapport;
};

window.gbDiag = gbDiag;
